"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.96789508,3.53369548 L10.2,12.4088889 L10.2,20.222222 L13.8,22 L13.8,12.4088889 L20.0321049,3.53369548 C20.3268568,3.06664112 20.187178,2.44907515 19.7201237,2.15432327 C19.5603722,2.0535062 19.3753319,2 19.1864282,2 L4.81357181,2 C4.26128706,2 3.81357181,2.44771525 3.81357181,3 C3.81357181,3.18890373 3.86707802,3.37394399 3.96789508,3.53369548 Z"
  });
}.bind(void 0));

exports.default = _default;